<template>
  <div class="page-container" v-if="currentNews">
    <h1 class="page-title">{{ currentNews.title }}</h1>
    <p style="text-align: right;">{{ currentNews.date }}</p>

    <div class="content">
      <!-- 顶部横幅图片 -->
      <div class="content-section image-section" v-if="currentNews?.image">
        <div class="image-container">
          <img :src="currentNews.image" alt="banner" />
        </div>
      </div>

      <!-- 文本段落 -->
      <div class="content-section" v-if="paragraphs.length">
        <div class="text-block" v-for="(p, idx) in paragraphs" :key="idx">
          <p>{{ p }}</p>
        </div>
      </div>

      <!-- 两张配图 -->
      <div class="content-section image-section" v-if="currentNews?.other?.picture1?.url">
        <div class="image-container">
          <img :src="currentNews.other.picture1.url" alt="picture1" />
        </div>
      </div>
      <div class="content-section image-section" v-if="currentNews?.other?.picture2?.url">
        <div class="image-container">
          <img :src="currentNews.other.picture2.url" alt="picture2" />
        </div>
      </div>
    </div>
  </div>
  <div v-else class="page-container">
    <p>新闻内容未找到</p>
  </div>
</template>

<script lang="ts" setup>
import { computed } from "vue";
import zhData from "../../../i18n/zh";
import enData from "../../../i18n/en";
import { useLangStore } from "../../../pinia/stores/lang";

const langStore = useLangStore();

const translationData = computed(() => (langStore.currentLang.startsWith("zh") ? zhData : enData));
const list = computed(() => translationData.value.pages.news.company.news.list || []);
const currentNews = computed(() => list.value.find((n: any) => n && n.id === "huanyihuanjiasupao"));
const paragraphs = computed(() => (currentNews.value?.content || "").split("---").map((s: string) => s.trim()).filter(Boolean));
</script>

<style scoped lang="scss">
.page-container {
  overflow: auto;
}
.content-section {
  margin-bottom: 20px;
}
.image-section {
  text-align: center;
}
.image-container {
  display: inline-block;
  margin: 10px 0;
}
.image-container img {
  max-width: 100%;
  border-radius: 4px;
}
.text-block p {
  margin: 16px 0;
  line-height: 1.8;
}
</style>